import { ModuleWithProviders, NgModule } from '@angular/core';
import { CUSTOM_PORTFOLIO_HEADER_REPORT_BUTTON } from '@cfp/domains/portfolio/header';
import { LbgReportBuildingsDownloadButton } from './lbg-portfolio-roadmap-report/components';
import { LbgSharedRouting } from './lbg-shared-routing';

@NgModule({
  imports: [LbgSharedRouting]
})
export class LbgSharedModule {
  static forRoot(): ModuleWithProviders<LbgSharedModule> {
    return {
      ngModule: LbgSharedModule,
      providers: [
        {
          provide: CUSTOM_PORTFOLIO_HEADER_REPORT_BUTTON,
          useValue: LbgReportBuildingsDownloadButton
        }
      ]
    };
  }
}
